export default __webpack_public_path__ + "static/media/Original.8e1b094e.png";